import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setPageTitle } from '../../actions/Page/PageAction';
import { getReportTicket } from '../../actions/Page/PageAction';
import Api from '../../Api';
import Constants from '../../Constants';

class Home extends React.Component {
  state = {
    load: true,
  };

  componentDidMount() {
    const { reportTicket, dashboard } = this.props;
    const { reportURL } = dashboard;
    this.props.setPageTitle('Landing Page');

    this.renderDashboard(reportURL, reportTicket);
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  componentDidUpdate(prevProps) {
    const { dashboard, getReportTicket, reportTicket, casDetails } = this.props;
    const { reportURL } = dashboard;
    const { casDetails: prevCasDetails, reportTicket: prevReportTicket } = prevProps;

    if (reportURL && reportURL !== prevProps.dashboard.reportURL) {
      getReportTicket();
    }

    if (reportTicket !== prevReportTicket) {
      this.renderDashboard(reportURL, reportTicket);
    }

    if (casDetails && prevCasDetails && casDetails.casId !== prevCasDetails.casId) {
      this.setState({ load: true }); // ?
    }
  }

  renderDashboard(reportURL, ticket) {
    if (!reportURL || !ticket) {
      return;
    }
    var api = new Api();
    let urlToken = Constants.apiUrls.reportTicket;
    api.getData(urlToken).then((resp) => {
      this.setState({ load: false });
      if (document.getElementById('tableau-report')) {
        document.getElementById('tableau-report').style.width = window.innerWidth - 260 + 'px';
      }
      const containerDiv = document.getElementById('tableau-report');

      const child = document.getElementById('renderDashboardReports');
      containerDiv && child && containerDiv.removeChild(child);

      const renderReportsElement = document.createElement('div');
      const length = reportURL.indexOf('views');
      const newUrl = reportURL.slice(0, length) + 'trusted/' + resp.ticket + '/' + reportURL.slice(length);
      renderReportsElement.setAttribute('id', 'renderDashboardReports');
      containerDiv.appendChild(renderReportsElement);
      const frameTitle = this.props.dashboard.reportDisplayName;
      const options = {
        onFirstInteractive: function (e) {
          containerDiv.querySelector('#renderDashboardReports iframe').setAttribute('title', frameTitle);
          containerDiv.querySelector('#renderDashboardReports iframe').setAttribute('aria-label', frameTitle);
        },
      };
      new window.tableau.Viz(renderReportsElement, newUrl, options);
      options.onFirstInteractive();
    });
  }

  render() {
    return (
      <React.Fragment>
        <h1 id="app_page_title" className="hide-by-pos">
          Landing Page
        </h1>
        <div className={`reports pTop-20 ${this.state.load ? 'hide' : ''}`}>
          <div tabIndex={'0'} className={'tableau-report iframe-container'} id="tableau-report">
            <div id="renderDashboardReports"></div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    casDetails: state.AppSession.activeCasDetails,
    reportTicket: state.Page.reportTicket,
    dashboard: state.Page.reportMenus.dashboard,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getReportTicket,
      setPageTitle,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(
  React.memo(Home, (prev, next) => {
    const useCache =
      prev.casDetails &&
      prev.casDetails.casId === next.casDetails.casId &&
      prev.dashboard.reportURL === next.dashboard.reportURL &&
      prev.reportTicket === next.reportTicket;
    return useCache;
  }),
);
